/**
 * IconWrapper style mappings.
 *
 * @internal Used by IconWrapper atom only.
 */

import type {
  IconWrapperColor,
  IconWrapperRotation,
  IconWrapperSize,
} from './IconWrapper.types';

export const sizeStyles: Record<IconWrapperSize, string> = {
  xs: 'w-3 h-3',
  sm: 'w-4 h-4',
  md: 'w-5 h-5 sm:w-6 sm:h-6',
  lg: 'w-6 h-6 sm:w-8 sm:h-8',
  xl: 'w-8 h-8 sm:w-10 sm:h-10',
};

export const colorStyles: Record<IconWrapperColor, string> = {
  primary: 'text-dark-invirtus',
  secondary: 'text-grey',
  white: 'text-white',
  error: 'text-red',
  purple: 'text-purple',
  green: 'text-green',
  blue: 'text-blue',
  inherit: 'text-inherit',
};

export const rotationStyles: Record<IconWrapperRotation, string> = {
  0: '',
  90: 'rotate-90',
  180: 'rotate-180',
  270: '-rotate-90',
};

/** Stroke width for Lucide icons; maps to [&>svg] stroke-width */
export const strokeWidthStyles: Record<number, string> = {
  1: '[&>svg]:stroke-[1]',
  1.5: '[&>svg]:stroke-[1.5]',
  2: '[&>svg]:stroke-2',
  2.5: '[&>svg]:stroke-[2.5]',
};
